
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_14iqq_3w4oy_13",
  "fit-height": "awsui_fit-height_14iqq_3w4oy_46",
  "with-side-media": "awsui_with-side-media_14iqq_3w4oy_51",
  "variant-default": "awsui_variant-default_14iqq_3w4oy_54",
  "variant-stacked": "awsui_variant-stacked_14iqq_3w4oy_54",
  "refresh": "awsui_refresh_14iqq_3w4oy_63",
  "sticky-enabled": "awsui_sticky-enabled_14iqq_3w4oy_113",
  "with-stuck-sticky-header-at-bottom": "awsui_with-stuck-sticky-header-at-bottom_14iqq_3w4oy_119",
  "focus-ring": "awsui_focus-ring_14iqq_3w4oy_126",
  "with-top-media": "awsui_with-top-media_14iqq_3w4oy_150",
  "content-wrapper": "awsui_content-wrapper_14iqq_3w4oy_155",
  "content-wrapper-fit-height": "awsui_content-wrapper-fit-height_14iqq_3w4oy_160",
  "media": "awsui_media_14iqq_3w4oy_167",
  "media-top": "awsui_media-top_14iqq_3w4oy_185",
  "media-side": "awsui_media-side_14iqq_3w4oy_190",
  "header": "awsui_header_14iqq_3w4oy_196",
  "header-full-page": "awsui_header-full-page_14iqq_3w4oy_201",
  "header-variant-embedded": "awsui_header-variant-embedded_14iqq_3w4oy_204",
  "header-sticky-enabled": "awsui_header-sticky-enabled_14iqq_3w4oy_204",
  "header-with-media": "awsui_header-with-media_14iqq_3w4oy_207",
  "header-sticky-disabled": "awsui_header-sticky-disabled_14iqq_3w4oy_213",
  "header-stuck": "awsui_header-stuck_14iqq_3w4oy_223",
  "header-variant-cards": "awsui_header-variant-cards_14iqq_3w4oy_233",
  "header-dynamic-height": "awsui_header-dynamic-height_14iqq_3w4oy_236",
  "with-paddings": "awsui_with-paddings_14iqq_3w4oy_242",
  "with-hidden-content": "awsui_with-hidden-content_14iqq_3w4oy_251",
  "header-variant-full-page": "awsui_header-variant-full-page_14iqq_3w4oy_309",
  "header-cover": "awsui_header-cover_14iqq_3w4oy_312",
  "content": "awsui_content_14iqq_3w4oy_155",
  "content-fit-height": "awsui_content-fit-height_14iqq_3w4oy_340",
  "content-inner": "awsui_content-inner_14iqq_3w4oy_346",
  "with-header": "awsui_with-header_14iqq_3w4oy_353",
  "footer": "awsui_footer_14iqq_3w4oy_357",
  "with-divider": "awsui_with-divider_14iqq_3w4oy_361"
};
  